<template>
  <div>
        <span @click="search()">
            <Button type="primary" @click="modal = true">{{$t('resourceLifecycle.add')}}</Button>
        </span>
    <Modal v-model="modal" :title="$t('resourceLifecycle.addresourcepricecoefficient')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}">
      <Form ref="resourcePriceCoefficientForm" :model="resourcePriceCoefficientForm" :label-width="100" :rules="ruleValidate">
        <!-- 公司 -->
        <div v-if="companyIdCookie==1">
          <FormItem :label="$t( 'resourceLifecycle.incorporation' )" prop="companyId">
            <Select v-model="resourcePriceCoefficientForm.companyId" filterable style="width:300px;">
              <Option :value="item.id" v-for="item in companyList" v-bind:key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
        </div>

        <!-- 云平台 -->
        <FormItem :label="$t( 'resourceLifecycle.cloudPlatform' )" prop="platform">
          <Select v-model="resourcePriceCoefficientForm.platform" filterable style="width:300px;">
            <Option :value="item.id" v-for="item in platformList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 资源类型 -->
        <FormItem :label="$t( 'resourceLifecycle.resourceType' )" prop="resourceType">
          <Select v-model="resourcePriceCoefficientForm.resourceType" filterable :placeholder="$t( 'resourceLifecycle.filterbyresourcetype' )" :transfer="true" style="width:300px;">
          <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 系数 -->
        <FormItem :label="$t( 'resourceLifecycle.coefficients' )" prop="coefficient">
          <InputNumber v-model="resourcePriceCoefficientForm.coefficient" style="width:300px;"></InputNumber>
        </FormItem>

        <!-- 描述 -->
        <FormItem :label="$t( 'resourceLifecycle.picturing' )" prop="remark">
          <Input v-model="resourcePriceCoefficientForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="" style="width:300px;"></Input>
        </FormItem>

        <!-- 最后价格
        <FormItem :label="$t( 'resourceLifecycle.lastPrice' )">
            <div>￥{{lastPrice}}</div>
        </FormItem>
        -->
      </Form>
      <div slot="footer">
        <Button @click="resourcePriceCoefficientReset('resourcePriceCoefficientForm')">{{$t('ticket.list.cancel')}}</Button>
        <Button type="primary" @click="resourcePriceCoefficientSubmit('resourcePriceCoefficientForm')">{{$t('ticket.list.confirm')}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
  import TableResourcePriceCoefficient from '../resource_price_coefficient/TableResourcePriceCoefficient.vue'
  var tableResourcePriceCoefficient = TableResourcePriceCoefficient;
  export default {
    data () {
      return {
        companyIdCookie: getCookie(global.companyId),
        lastPrice: '',
        companyList:[],
        platformList:[{
          id:0,
          name:'AWS'
        },{
          id:2,
          name:'Azure'
        }],
        resourceTypeList: [{
          id: 0,
          name: this.$t( 'resourceLifecycle.vMs' )
        }, {
          id: 1,
          name: this.$t( 'resourceLifecycle.virtualNetwork' )
        }, {
          id: 2,
          name: this.$t( 'resourceLifecycle.objectstorage' )
        }, {
          id: 3,
          name: this.$t( 'resourceLifecycle.manageddatabase' )
        }, {
          id: 4,
          name: this.$t( 'resourceLifecycle.elasticIP' )
        }, {
          id: 5,
          name: this.$t( 'resourceLifecycle.azureMySQLServer' )
        }, {
          id: 6,
          name: this.$t( 'resourceLifecycle.azureMariaDBServer' )
        }, {
          id: 7,
          name: this.$t( 'resourceLifecycle.azureRedisServer' )
        }],
        resourcePriceCoefficientForm: {
          companyId: '',
          platform: 0,
          resourceType: 0,
          coefficient:1,
          remark: ''
        },
        loading: true,
        modal:false,
        ruleValidate: {
          companyId: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseselectacompany' ), trigger: 'change',type:'number'  }
          ],
          platform: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseselectthecloudplatform' ), trigger: 'change',type:'number'  }
          ],
          resourceType: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheresourcetype' ), trigger: 'change',type:'number'  }
          ],
          coefficient: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterthecoefficient' ), trigger: 'blur', type: 'number'}
          ],
          remark: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseenteradescription' ), trigger: 'blur'}
          ]
        }
      }
    },
    mounted:function(){
      if (this.companyIdCookie == 1){
        this.getCompanyList();
      }
    },
    methods:{
      search: function(){
      },
      // 公司列表
      getCompanyList: function () {
        this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
          .then(res => {
            this.companyList = res.data;
            if (this.companyList != null && this.companyList != undefined && this.companyList.length > 0){
              this.resourcePriceCoefficientForm.companyId =  this.companyList[0].id;
            }
          });
      },
      resourcePriceCoefficientSubmit: function(name){
        this.$refs[name].validate(valid => {
          if(valid){
            // 添加
            this.$api.lifecycleResourcePriceAdjustment.create({
              "companyId": this.resourcePriceCoefficientForm.companyId,
              "platform": this.resourcePriceCoefficientForm.platform,
              "lifecycleResourceType": this.resourcePriceCoefficientForm.resourceType,
              "adjustCoefficient": this.resourcePriceCoefficientForm.coefficient,
              "originCost": this.resourcePriceCoefficientForm.lastPrice,
              "remark": this.resourcePriceCoefficientForm.remark
            })
              .then(res => {
                setTimeout(() => {
                  tableResourcePriceCoefficient.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t( 'resourceLifecycle.response.addSuccess' ));
                  this.modal = false;
                },1000);
              })
          }else{
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t( 'resourceLifecycle.response.addFail' ));
          }
        });
      },
      resourcePriceCoefficientReset: function(name){
        this.modal = false;
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_operation_report/resource_price_coefficient/AddResourcePriceCoefficient.vue